import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { UsersPagination, UsersService } from '../../services/users.service';
import * as UsersActions from './users.actions';

@Injectable()
export class UsersEffects {
  private actions$ = inject(Actions);
  private usersService = inject(UsersService);

  // Load Users Effect
  loadUsers$ = createEffect(() =>
this.actions$.pipe(
      ofType(UsersActions.loadUsers),
      switchMap(({ page, limit, search }) => {
        return this.usersService.getUsers(page, limit, search).pipe(
          map((paginationResp: UsersPagination) =>
            UsersActions.loadUsersSuccess({
              pagination: paginationResp,
              totalItems: paginationResp.total, // Pass total from response
            })
          ),
          catchError((error) => {
            return of(UsersActions.loadUsersFailure({ error }));
          })
        );
      })
    )
 
  );

  // Load Single User Effect
  loadUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UsersActions.loadUser),
      switchMap(({ userId }) =>
        this.usersService.getUserById(userId).pipe(
          map((user) => UsersActions.loadUserSuccess({ user })),
          catchError((error) => of(UsersActions.loadUserFailure({ error })))
        )
      )
    )
  );

  // Create User Effect
  createUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UsersActions.createUser),
      switchMap(({ userData }) =>
        this.usersService.createUser(userData).pipe(
          map((user) => UsersActions.createUserSuccess({ user })),
          catchError((error) => of(UsersActions.createUserFailure({ error })))
        )
      )
    )
  );

  // Update User Effect
  updateUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UsersActions.updateUser),
      switchMap(({ userId, updates }) =>
        this.usersService.updateUser(userId, updates).pipe(
          map((user) => UsersActions.updateUserSuccess({ user })),
          catchError((error) => of(UsersActions.updateUserFailure({ error })))
        )
      )
    )
  );

  // Delete User Effect
  deleteUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UsersActions.deleteUser),
      switchMap(({ userId }) =>
        this.usersService.deleteUser(userId).pipe(
          map(() => UsersActions.deleteUserSuccess({ userId })),
          catchError((error) => of(UsersActions.deleteUserFailure({ error })))
        )
      )
    )
  );
}
